module.exports = __webpack_public_path__ + "img/arrow-down.7da2026c.svg";